import {DOM} from "../../../../public/js/utils/DOM";
import {ControlsForm} from "../../Form/Form";
import {CollectedValuesType} from "../../Form/definitions/CollectedValuesType";
import {ControlsGeneralTableControl} from "../TableControl/TableControl";

export namespace ControlsGeneralFilterControl {

    class Config {
        public static readonly activeClassName = "open";
        public static readonly dropDownClassName = "FilterControl-content-inside";
        public static readonly submitClass = "filterControlSave";
        public static readonly clearClass = "filterControlClear";
        public static readonly buttonClassName = "FilterControl-content-button";
        public static readonly filterCloseElementClass = "filterClose";
    }

    export class Utils {

        /**
         * Get form data from filter
         * @param filterId
         */
        public static getFilterDataByFilterId(filterId: string) : CollectedValuesType {
            return ControlsForm.Controller.getFormData(
                DOM.Parser.getElementByTag('form',
                    DOM.Parser.getHtmlElement(filterId)) as HTMLFormElement);
        }

        /**
         * Get filter is opened
         * @param filterId
         */
        public static getFilterActiveByFilterId(filterId: string) : boolean {
            return DOM.Parser.getHtmlElement(filterId).classList.contains(Config.activeClassName);
        }

        /**
         * Disable/enable filter actions
         * @param filterId - filter id
         * @param disabled - disabled
         */
        public static disableEnableActionsInFilter(filterId: string, disabled: boolean) : void {

            const buttons = DOM.Parser.getHtmlElementsByQuery('button', DOM.Parser.getHtmlElement(filterId)) as NodeListOf<HTMLButtonElement>;
            for (let i = 0; i < buttons.length; i++) {
                buttons[i].disabled = disabled;
            }
        }
    }

    export class Control {

        // Container element
        private readonly filterElement: HTMLElement;

        // Filter container element ID
        private readonly filterId: string;

        // Action when clicked to send button
        private readonly sendFilterActionCallback: (event: Event) => void;

        // After clear success action
        private readonly clearSuccessCallback: () => void;

        // Name of component with included filter
        private readonly componentNameIncluded: string;

        constructor(filterId: string, componentNameIncluded: string, sendFilterActionCallback: (event: Event) => void, clearSuccessCallback: () => void) {

            this.componentNameIncluded = componentNameIncluded;
            this.sendFilterActionCallback = sendFilterActionCallback;
            this.clearSuccessCallback = clearSuccessCallback;
            this.filterElement = DOM.Parser.getHtmlElement(filterId);
            this.filterId = filterId;

            this.triggerHideOnOutsideClick();
            this.triggerDropDown();
            this.triggerSend();
            this.triggerClear();
            this.triggerClose();
        }

        /**
         * Close filter pop-up action
         * Just change main filter element class
         * @private
         */
        private triggerClose() : void {
            DOM.Parser.getHtmlElementByClass(Config.filterCloseElementClass, this.filterElement).addEventListener('click', () => {
                this.filterElement.classList.remove(Config.activeClassName);
            })
        }

        /**
         * Call clear action
         * The action is called on included component (not filter component!)
         * @private
         */
        private triggerClear() : void {
            ControlsGeneralTableControl.Filter.triggerClearFilter(
                DOM.Parser.getHtmlElementByClass(Config.clearClass, this.filterElement),
                this.componentNameIncluded,
                () => { this.clearSuccessCallback(); }
            );
        }

        /**
         * Call send filter action
         * The action is called on included component (not filter component!)
         * @private
         */
        private triggerSend() : void {
            ControlsGeneralTableControl.Filter.triggerSendFilter(
                DOM.Parser.getElementByTag('form', this.filterElement) as HTMLFormElement,
                DOM.Parser.getHtmlElementByClass(Config.submitClass, this.filterElement) as HTMLButtonElement,
                (event: Event) => { this.sendFilterActionCallback(event); }
            );
        }

        /**
         * Action to close pop-up after clicking outside
         * @private
         */
        private triggerHideOnOutsideClick() : void {

            window.addEventListener('click', (evt: MouseEvent) => {
                const filterElement: HTMLElement|null = document.getElementById(this.filterId);
                if (filterElement === null || !filterElement.classList.contains(Config.activeClassName)) { return; }
                const clickedInside =
                    DOM.Parser.parentContainsTheClass(Config.dropDownClassName, evt.target as HTMLElement)
                    || DOM.Parser.parentContainsTheClass('flatpickr-calendar', evt.target as HTMLElement);
                if (clickedInside) { return; }
                filterElement.classList.remove(Config.activeClassName);
            });
        }

        /**
         * Trigger pop-up toggle on button click
         * @private
         */
        private triggerDropDown() : void {

            const button = DOM.Parser.getHtmlElementByClass(Config.buttonClassName, this.filterElement);
            button.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault(); event.stopPropagation();
                this.filterElement.classList.toggle(Config.activeClassName);
            })
        }
    }
}